module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Select-f350361859ef7ab7427332bccbe7eab9cc3f564236d3a9f6a167825e5c9cd2a2.svg";